import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Typography, useTheme, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme.js";
import urls from '../../constants/urls.js';
//import { schoolsData } from "../../data/mockData.js";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import Header from "../../components/Header.jsx";
//import { Button } from "antd";
//import urls from './../../../constants/urls';

export default function SchoolTeachersData({ sendDataToParent, schoolIdGlobal }) {
 
  
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  
  const [APIROOTURL, setAPIROOTURL]=useState(urls.rootAPIURL);
  const[rootAPIURL, setRootAPIURL]=useState('');
  const[schoolsData, setSchoolsData]=useState([]);
  const[formDataSchool, setFormDataSchool]=useState({});
 
  const openUpdateSchool=(category, users_id, first_name, ward_id, district_id,city_id, mobile_number, city_name, middle_name, last_name, full_name, gender, date_of_birth, password_id, user_password, login_category_id, login_category_name, school_id, school_name, user_email)=>{
    console.log("school id=" + users_id)
    console.log("user email=" + user_email)
    sendDataToParent(category, users_id, first_name, ward_id, district_id,city_id, mobile_number, city_name, middle_name, last_name, full_name, gender, date_of_birth, password_id, user_password, login_category_id, login_category_name, school_id, school_name, user_email);
        
  }

   
  
  const columns = [
    { 
      field: "id", 
      headerName: "SNo" 
    },
    { 
      field: "full_name", 
      headerName: "Full name" ,
      flex:2,
    },

    {
      field: "gender",
      headerName: "Gender",
      flex: 0.5,
    },
    
    {
      field: "mobile_number",
      headerName: "Mobile No",
      flex: 1,
      cellClassName: "name-column--cell",
    },
   
    {
      field: "user_email",
      headerName: "Email",
      type: "string",
      headerAlign: "left",
      align: "left",
      flex:1.5,
    },
    {
      field: "user_password",
      headerName: "Password",
      flex: 1,
    },
    
    {
      field: "login_category_id",
      headerName: "Update",
      flex: 1,
      renderCell: ({ row: { users_id, first_name, ward_id, district_id,city_id, mobile_number, city_name, middle_name, last_name, full_name, gender, date_of_birth, password_id, user_password, login_category_id, login_category_name, school_id, school_name, user_email } }) => {
        return (
          <Box
            width="60%"
            m="0 auto"
            p="5px"
            display="flex"
            justifyContent="center"
            //backgroundColor={}
            borderRadius="4px"
          >
            
            <Button 
           type="submit" color="secondary" variant="contained"
           sx={{ marginLeft: '12px', width: '150px', marginTop: '10px'}}
           //                             users_id, first_name, ward_id, district_id,city_id, mobile_number, city_name, middle_name, last_name, full_name, gender, date_of_birth, password_id, user_password, login_category_id, login_category_name, school_id, school_name, user_email
           onClick={()=>openUpdateSchool("update", users_id, first_name, ward_id, district_id,city_id, mobile_number, city_name, middle_name, last_name, full_name, gender, date_of_birth, password_id, user_password, login_category_id, login_category_name,  school_id, school_name, user_email)}
           >
                Update
            </Button>
          </Box>
        );
      },
    },


    
    {
      field: "login_category_name",
      headerName: "SUBJECTS",
      flex: 1,
      renderCell: ({ row: { users_id, first_name, ward_id, district_id,city_id, mobile_number, city_name, middle_name, last_name, full_name, gender, date_of_birth, password_id, user_password, login_category_id, login_category_name, school_id, school_name, user_email } }) => {
        return (
          <Box
            width="60%"
            m="0 auto"
            p="5px"
            display="flex"
            justifyContent="center"
            //backgroundColor={}
            borderRadius="4px"
          >
            
            <Button 
           type="submit" color="secondary" variant="contained"
           sx={{ marginLeft: '12px', width: '150px', marginTop: '10px'}}
           //                             users_id, first_name, ward_id, district_id,city_id, mobile_number, city_name, middle_name, last_name, full_name, gender, date_of_birth, password_id, user_password, login_category_id, login_category_name, school_id, school_name, user_email
           onClick={()=>openUpdateSchool("subjects", users_id, first_name, ward_id, district_id,city_id, mobile_number, city_name, middle_name, last_name, full_name, gender, date_of_birth, password_id, user_password, login_category_id, login_category_name,  school_id, school_name, user_email)}
           >
                SUBJECTS
            </Button>
          </Box>
        );
      },
    },
  ];
  

  const loadDataToSchoolTeachersData=(data)=>{
    let iList=[]
    
    {
      data.map(function(dt, index){
          let ix=index+1
          iList.push(
            { 
              id: ix,
              users_id: dt.users_id,
              first_name: dt.first_name,
              middle_name: dt.middle_name,
              last_name: dt.last_name,
              full_name: dt.full_name,
              gender: dt.gender,
              mobile_number: dt.mobile_number,
              user_email: dt.user_email,
             
              date_of_birth: dt.date_of_birth,
              password_id: dt.password_id,
              user_password: dt.user_password,
              login_category_id: dt.login_category_id,
              login_category_name: dt.login_category_name,
              school_id: dt.school_id,
              school_name: dt.school_name,
            })

            console.log("dt.first_name=" + dt.first_name)
            console.log("dt.middle_name=" + dt.middle_name)
            console.log("dt.last_name=" + dt.last_name)

            console.log("dt.full_name=" + dt.full_name)
            console.log("dt.gender=" + dt.gender)
            console.log("dt.mobile_number=" + dt.mobile_number)

            console.log("dt.user_email=" + dt.user_email)
            console.log("dt.password_id=" + dt.password_id)
            console.log("dt.user_password=" + dt.user_password)
        
      })
    }

    setSchoolsData(iList)
  }


  const postNewSchool =()=>{
    //rootAPIURL
    let url = rootAPIURL + "/tax/createTaxPaymentViewEXT/";
    url = rootAPIURL + "/tax/createTaxPaymentViewEXT";
    let picsId=0;
    axios
      .post(url, formDataSchool, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("res.data=" + res.data);
        console.log("res.data.msgx=" + res.data.msgx);
        //console.log(rootAPIURL + "/" + receiptNumber + ".png");
        //
        
        //setQRValue(rootAPIURL + "/" + receiptNumber + ".png");
        alert(res.data.msg);
       

       //setCounter(res.data.counter);
       //printReceipt(receiptNumber);
       
      })
      .finally(() => {
        
      })
      .catch((err) => console.log(err));
  }

  //}
  
  useEffect(()=>{
    
    let APIURL= APIROOTURL + "SingleSchoolTeachersViewEXT/" + schoolIdGlobal
    let headerOptions={
        method: 'GET',
       
    } 
    
    console.log(" QWE132 url APIURL =" + APIURL);

    fetch(APIURL, headerOptions)
    .then( response => response.json())
    .then( json=> {
        //loadDataToSchoolTeachersData
        //setupReportData(json);
        loadDataToSchoolTeachersData(json)
        //setShowReport1(true);

        //console.log(" QWE132 data00=" + json);
        console.log(" QWE132data[0].name=" + json[0].first_name);
    })
    .finally((json) =>{ 
       // console.log("data01=" + json[0].name);
    })
    .catch( (error)=> console.log("QWE132 fetch school data error=" + error))


  }, [])



  return (
        
        <div>
        <DataGrid checkboxSelection rows={schoolsData} columns={columns} />
        </div>
  );

}
